import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 350px;
  display: flex;
  align-self: flex-end;
  flex-direction: column;
  margin: 32px 0 12px 0;
  gap: 8px;

  [class*='Container'] > [class*='BaseText'] {
    display: none;
  }
`;
